import { BaseFiltroPagDTO } from '@/interfaces/base-dto';
import { IRule, IOperator, IProperty } from '@/interfaces/rules-engine';
import {
  FIELD_TYPE_ID,
  FIELD_TYPE_ENUMERATED,
  OVERRIDE_WEIGHT_EMEDE,
  REFERENCE_TYPE_EMEDE,
} from '@/settings/consts/rules-engine';

export default class RuleModel {
  public id: string;
  public codigo: string;
  public descricao: string;
  public acao: string;
  public mensagem: string;
  public textoExplicativo: string;
  public solicitarCiente: boolean;
  public palavraChaveCiente: string;
  public condicoes: any[];
  public ativo: boolean;

  constructor(_initialValues?: IRule) {
    const initialValues = _initialValues || {
      id: '',
      codigo: '',
      descricao: '',
      acao: '',
      mensagem: '',
      textoExplicativo: '',
      solicitarCiente: false,
      palavraChaveCiente: '',
      condicoes: [],
      ativo: true,
    };

    this.id = initialValues.id;
    this.codigo = initialValues.codigo;
    this.descricao = initialValues.descricao;
    this.acao = initialValues.acao;
    this.mensagem = initialValues.mensagem;
    this.textoExplicativo = initialValues.textoExplicativo;
    this.solicitarCiente = initialValues.solicitarCiente;
    this.palavraChaveCiente = initialValues.palavraChaveCiente;
    this.condicoes = initialValues.condicoes;
    this.ativo = initialValues.ativo;
  }

  public formatConditions(
    conditions: any[],
    entities: any[],
    operators: any[],
    properties: any[],
  ): void {
    if (!conditions) {
      this.condicoes = [];
      return;
    }

    this.condicoes = conditions.map((condicao: any) => {
      const entidade = entities.find((e) => e.classe === condicao.entidade);
      if (!!entidade) {
        const campo = entidade.campos.find((c) => c.nome === condicao.campo);

        if (!!campo) {
          if (
            entidade.classe.indexOf('Insumo') !== -1 &&
            !!campo.unidadeMedida
          ) {
            campo.descricao = `${campo.descricao} ( ${campo.unidadeMedida} )`;
          }
          const field = operators.find((o) => o.tipo === campo.tipo);
          const operador = !!field
            ? field.operadores.find((o) => o.operator === condicao.operador)
            : { descricao: condicao.operador };

          let crivoLabel;
          if (
            campo.tipo === FIELD_TYPE_ID ||
            campo.tipo === FIELD_TYPE_ENUMERATED
          ) {
            const crivoFound = campo.itensIdentificaveis.find(
              (item) => item.id === condicao.idPropriedade,
            );

            if (!!crivoFound) {
              crivoLabel = crivoFound.label;
            }
          } else {
            const property = properties.find(
              (p) => p.id === condicao.idPropriedade,
            );
            crivoLabel = `${property.descricao} ( ${property.valor} )`;
          }

          const crivo = {
            id: condicao.idPropriedade,
            label: crivoLabel,
          };

          return {
            campo,
            entidade,
            idPropriedade: condicao.idPropriedade,
            id: condicao.id,
            crivo,
            operador,
            isNew: false,
          };
        }
      }
    });
  }

  public validate(): boolean {
    return (
      !!this.codigo &&
      !!this.descricao &&
      !!this.acao &&
      !!this.condicoes.length
    );
  }
}

